import {
    Card,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from 'next/link';

export default function JobsCard({
    title,
    description,
    url_slug,
    addresses,
    published_at,
    salary_package,
    categories,
    post_lang = ""
}) {
    const contractType = categories?.map((cat) => cat.id == "90f0c208-6dd9-4e68-accd-7e637ade733f" && cat.values?.map((value) => value.name))
    const sector = categories?.map((cat) => cat.id == "90291455-4c9a-428f-b32b-87e4523fd608" && cat.values?.map((value) => <><span>{value.name}</span></>))

    return (
        <>
            <Card className={`${styles.root} h-100 overflow-hidden w-100 border rounded-4 p-3`}>
                <Link href={`${post_lang}/jobs/${url_slug}/`}>
                    <a className="text-decoration-none d-flex flex-wrap justify-content-between h-100">
                        <Card className="border-0 bg-transparent">
                            <div className="post-sector d-inline-block">
                                {sector?.length >= 1 ?
                                    sector
                                    : ""}
                            </div>
                            <p className="fs-5 post-title mt-2 mb-4"><strong>{title}</strong></p>
                            {addresses ?
                                <p className="post-location mb-0">
                                    {addresses}
                                </p>
                                : null}
                            {contractType ?
                                <p className="post-type mb-0">
                                    {contractType}
                                </p> : null}
                            {salary_package ?
                                <p className="post-salary mt-3">
                                    {salary_package === "Up to US$0.00 per hour" ? "Competitive" : salary_package}</p>
                                : null}
                        </Card>
                    </a>
                </Link>
            </Card>
        </>
    )
}